import { useCallback } from 'react';
import { DetailsModalView } from './DetailsModal.utils';

interface UseDetailsModalViewHandlersParams {
  isEdit: boolean;
  onViewChange: (view: DetailsModalView) => void;
  onClose: () => void;
}

export const useDetailsModalViewHandlers = ({
  isEdit,
  onViewChange,
  onClose,
}: UseDetailsModalViewHandlersParams) => {
  const handleFormCancel = useCallback(() => {
    if (isEdit) return onViewChange(DetailsModalView.Details);

    onClose();
  }, [isEdit, onViewChange, onClose]);

  const handleEdit = useCallback(
    () => onViewChange(DetailsModalView.Form),
    [onViewChange]
  );

  return { handleFormCancel, handleEdit };
};
